.co{outline:none;}